// src/config/api.js
const isProduction = true
const API_BASE_URL = isProduction ? 'https://e-sangha.atomsoft.co' : 'http://localhost:5001'

export default API_BASE_URL;
